// trade-format.js — shared helpers for the trades relation.
//
// Backend returns trades as an array on each user record:
//   trade_of_works: [{ id, trade_name }, ...]
// These helpers turn that array into display text consistently across the app.

export const formatTradeLabel = (trade) => trade?.trade_name || "";

// Joins all trades into one string, e.g. "Roofing, Siding".
// Returns "" when there are none (callers decide the fallback like "N/A" / "—").
export const formatTrades = (trades) => {
  if (!Array.isArray(trades) || trades.length === 0) return "";
  return trades.map(formatTradeLabel).filter(Boolean).join(", ");
};
